var SurveyViewService = require('../survey-service');

var SurveyService = function() {
  this.triggerSurvey = function(blockView) {
    var url = SurveyViewService.surveyUrl(blockView.model.get('slug'), blockView.model.get('return_hash'));
    if(url === undefined) {
      console.warn('No Survey url');
      return;
    }
    else {
      setTimeout(_.bind(function() {
        Chaplin.mediator.publish('window:navigate', url);
      }, this), 2000);
    }
  };

  this.userHasCompletedSurvey = function(courseSlug) {
    return !!SurveyViewService.getActivityProgressForSlug(courseSlug);
  };

  this.getSurvey = function(blockView) {
    return blockView.model.get('survey').fetch({
      error: function(err) {
        console.error('Error fetching survey: ', err);
      },
      success: function() {
        blockView.model.get('survey').initResponseSet({
            success: (responseSet) => {
              blockView.model.set('responseSet', responseSet);
              // sections is not set on the survey model for some reason
              // this has to be handled here or in the template
              blockView.model.get('survey').set('sections', blockView.model.get('survey').sections);
              blockView.render();
            }
          }
        );
      }
    });
  };

  this.saveSurveyResponse = function(blockView, dataset, options) {
      if(options && options.multipleQuestion) {
        blockView.model.get('responseSet').answerQuestions(dataset);
      } else {
        blockView.model.get('responseSet').answerQuestion(dataset.questionId, dataset.answerId);
      }
      return blockView.model.get('responseSet').save();
  };
  this.refreshResponseSet = function() {}
};

module.exports = new SurveyService();
